"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var storefront_service_1 = require("./storefront.service");
var free_gifts_popup_template_1 = require("../templates/free-gifts-popup.template");
var common_helper_1 = require("../helpers/common.helper");
var spend_more_template_1 = require("../templates/spend-more.template");
var config_1 = require("../config/config");
var FreeGiftsService = /** @class */ (function () {
    function FreeGiftsService() {
        this.store = window[config_1["default"].storeKey];
        this.thresholds = null;
        this.storefrontService = new storefront_service_1["default"]();
    }
    FreeGiftsService.prototype.isCartQualify = function () {
        return __awaiter(this, void 0, void 0, function () {
            var threshold, freeGiftsNumber, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.getQualifiedThreshold()];
                    case 1:
                        threshold = _a.sent();
                        this.store.currentThreshold = threshold;
                        if (!threshold) {
                            return [2 /*return*/, false];
                        }
                        freeGiftsNumber = this.getCartFreeGiftsData();
                        return [2 /*return*/, freeGiftsNumber < threshold.numberOfFreeGifts];
                    case 2:
                        err_1 = _a.sent();
                        console.log(err_1);
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FreeGiftsService.prototype.getPopupItemsHtml = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!!this.store.currentThreshold) return [3 /*break*/, 2];
                        _a = this.store;
                        return [4 /*yield*/, this.getQualifiedThreshold()];
                    case 1:
                        _a.currentThreshold = _b.sent();
                        _b.label = 2;
                    case 2:
                        if (!this.store.currentThreshold) {
                            return [2 /*return*/, ''];
                        }
                        return [2 /*return*/, free_gifts_popup_template_1["default"](this.store.currentThreshold)];
                }
            });
        });
    };
    FreeGiftsService.prototype.getSpendMoreHtml = function () {
        return __awaiter(this, void 0, void 0, function () {
            var qualifiedThreshold, nextThreshold;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getQualifiedThreshold()];
                    case 1:
                        qualifiedThreshold = _a.sent();
                        return [4 /*yield*/, this.getNextThreshold(qualifiedThreshold)];
                    case 2:
                        nextThreshold = _a.sent();
                        return [2 /*return*/, spend_more_template_1["default"](qualifiedThreshold, nextThreshold, this.store.cart)];
                }
            });
        });
    };
    FreeGiftsService.prototype.getThresholds = function () {
        return __awaiter(this, void 0, void 0, function () {
            var results, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.storefrontService.get('thresholds')];
                    case 1:
                        results = _a.sent();
                        if (!results) {
                            return [2 /*return*/, false];
                        }
                        if (!results.success) {
                            return [2 /*return*/, false];
                        }
                        if (!results.data.length) {
                            return [2 /*return*/, false];
                        }
                        return [2 /*return*/, results.data];
                    case 2:
                        err_2 = _a.sent();
                        console.log(err_2);
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FreeGiftsService.prototype.getCartFreeGiftsData = function () {
        var cartSampleIds = common_helper_1.getCartItemsIdByType(this.store.cart, 'Sample');
        var cartGwpIds = common_helper_1.getCartItemsIdByType(this.store.cart, 'GWP');
        var customCouponItem = common_helper_1.getCustomCouponProductCartItem();
        if (customCouponItem) {
            if (customCouponItem.properties._custom_coupon.options.isGwpAllowed) {
                cartGwpIds = cartGwpIds.filter(function (e) { return e.toString() !== customCouponItem.id.toString(); });
            }
        }
        return cartSampleIds.length + cartGwpIds.length;
    };
    FreeGiftsService.prototype.getQualifiedThreshold = function () {
        return __awaiter(this, void 0, void 0, function () {
            var qualifiedThreshold, cartTotal, thresholds, _i, thresholds_1, threshold, cloneThreshold;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        qualifiedThreshold = null;
                        cartTotal = common_helper_1.getCartTotal(this.store.cart);
                        return [4 /*yield*/, this.store.thresholds];
                    case 1:
                        thresholds = _a.sent();
                        if (!thresholds) {
                            return [2 /*return*/, qualifiedThreshold];
                        }
                        thresholds.sort(function (a, b) { return (a.value > b.value) ? 1 : -1; });
                        for (_i = 0, thresholds_1 = thresholds; _i < thresholds_1.length; _i++) {
                            threshold = thresholds_1[_i];
                            if (!threshold.enabled) {
                                continue;
                            }
                            cloneThreshold = __assign({}, threshold);
                            if (cartTotal >= cloneThreshold.value) {
                                qualifiedThreshold = threshold;
                            }
                        }
                        return [2 /*return*/, qualifiedThreshold];
                }
            });
        });
    };
    FreeGiftsService.prototype.getNextThreshold = function (currentThreshold) {
        return __awaiter(this, void 0, void 0, function () {
            var thresholds, i;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.store.thresholds];
                    case 1:
                        thresholds = _a.sent();
                        if (!thresholds) {
                            return [2 /*return*/, null];
                        }
                        if (!currentThreshold) {
                            return [2 /*return*/, thresholds[0] ? thresholds[0] : null];
                        }
                        for (i = 0; i < thresholds.length; i++) {
                            if (thresholds[i].value === currentThreshold.value) {
                                if (thresholds[i + 1]) {
                                    return [2 /*return*/, thresholds[i + 1]];
                                }
                                return [2 /*return*/, null];
                            }
                        }
                        return [2 /*return*/, null];
                }
            });
        });
    };
    return FreeGiftsService;
}());
exports["default"] = FreeGiftsService;
